import { ElementRef } from '@angular/core';
import { IItemSettings } from '../interface/item-settings';

export function applyItemSettings(
  data: any,
  itemParentEl: ElementRef<HTMLElement>
): void {
  const itemSettingsComposition = (data && data.itemSettingsComposition) || {};

  const {
    itemTitleFontWeight,
    itemTitleSize,
    itemTitleColor,
    itemBackgroundColor,
    itemBorderRadius,
    itemTextSize,
    itemFontWeight,
    itemFontColor,
  } = itemSettingsComposition;

  const titleFontWeight = itemTitleFontWeight && itemTitleFontWeight.value; 
  const titleFontSize = itemTitleSize && itemTitleSize.value;
  const titleColor = itemTitleColor && itemTitleColor.value;
  const backgroundColor = itemBackgroundColor && itemBackgroundColor.value;
  const borderRadius = itemBorderRadius && itemBorderRadius.value;
  const textSize = itemTextSize && itemTextSize.value;
  const textFontWeight = itemFontWeight && itemFontWeight.value;
  const textFontColor = itemFontColor && itemFontColor.value;

  if (itemParentEl && itemParentEl.nativeElement) {
    if (titleFontWeight) {
      itemParentEl.nativeElement.style.setProperty('--item-settings-title-font-weight', titleFontWeight);
    }
    if (titleFontSize) {
      itemParentEl.nativeElement.style.setProperty('--item-settings-title-font-size', titleFontSize + 'px');
    }
    if (titleColor) {
      itemParentEl.nativeElement.style.setProperty('--item-settings-title-font-color', titleColor);
    }
    if (backgroundColor) {
      itemParentEl.nativeElement.style.setProperty('--item-settings-background-color', backgroundColor);
    }
    if (borderRadius) {
      itemParentEl.nativeElement.style.setProperty('--item-settings-border-radius', borderRadius + 'px');
    }
    if (textSize) {
      itemParentEl.nativeElement.style.setProperty('--item-settings-text-size', textSize + 'px');
    }
    if (textFontWeight) {
      itemParentEl.nativeElement.style.setProperty('--item-settings-text-font-weight', textFontWeight);
    }
    if (textFontColor) {
      itemParentEl.nativeElement.style.setProperty('--item-settings-text-font-color', textFontColor);
    }
  }
}



